// Mock data for STEAM-IE Website

export const stats = [
  { id: 1, value: 17, suffix: '+', label: 'Years of Excellence', description: 'Pioneering STEM education since 2008' },
  { id: 2, value: 2500, suffix: '+', label: 'Students Empowered', description: 'Certified STEAM-IE graduates' },
  { id: 3, value: 250, suffix: '+', label: 'Educators Trained', description: 'Certified instructors nationwide' },
  { id: 4, value: 25, suffix: '+', label: 'Partner Schools', description: 'Accredited institutions' }
];

export const offerings = [
  {
    id: 1,
    title: 'K-12 STEM Education',
    description: 'Comprehensive curriculum designed for students from Kindergarten through 12th grade, fostering critical thinking and innovation. Fully aligned with NEP guidelines and NCF 2023 standards.',
    icon: 'GraduationCap',
    features: ['Age-appropriate learning paths', 'Hands-on experiments', 'Project-based assessments', 'NEP Aligned & NCF 2023 Standards'],
    image: 'https://customer-assets.emergentagent.com/job_stemkits-lms/artifacts/nt5hnb1g_Gemini_Generated_Image_d58dzzd58dzzd58d.png'
  },
  {
    id: 2,
    title: 'STEAM-IE Kits',
    description: 'Premium robotics and coding kits delivered to your doorstep, complete with guided lessons, LMS access, and certifications. Aligned with vocational education standards.',
    icon: 'Package',
    features: ['Microcontroller-based systems', 'Python programming', 'Vocational Education Aligned', 'LMS & Video tutorials'],
    image: 'https://customer-assets.emergentagent.com/job_stemkits-lms/artifacts/eqozrikd_Gemini_Generated_Image_rx9oderx9oderx9o.png'
  },
  {
    id: 3,
    title: 'Learning Management System',
    description: 'State-of-the-art LMS platform for seamless online learning, progress tracking, and interactive content delivery.',
    icon: 'Monitor',
    features: ['Live virtual classes', 'Progress analytics', 'Interactive quizzes', 'Certificate generation'],
    image: 'https://customer-assets.emergentagent.com/job_stemkits-lms/artifacts/50fot5kt_Gemini_Generated_Image_8g45o08g45o08g45.png'
  },
  {
    id: 4,
    title: 'Customised Learning',
    description: 'Tailored programs designed to meet individual student needs, learning pace, and specific educational goals.',
    icon: 'Settings',
    features: ['Personalized curriculum', 'One-on-one mentoring', 'Adaptive assessments', 'Flexible scheduling'],
    image: 'https://customer-assets.emergentagent.com/job_stemkits-lms/artifacts/iez8ve3p_Gemini_Generated_Image_tms379tms379tms3.png'
  },
  {
    id: 5,
    title: 'School Management Platform',
    description: 'Complete training and management solution for schools to implement and track STEM education programs.',
    icon: 'Building',
    features: ['Teacher training modules', 'Administration dashboard', 'Parent communication', 'Performance reports'],
    image: 'https://customer-assets.emergentagent.com/job_stemkits-lms/artifacts/8m35ln1z_Gemini_Generated_Image_1dxgmf1dxgmf1dxg.png'
  },
  {
    id: 6,
    title: 'Innovation Labs',
    description: 'Setup and support for school-based innovation labs with cutting-edge equipment and expert guidance.',
    icon: 'Lightbulb',
    features: ['Lab setup consultation', 'Equipment procurement', 'Maintenance support', 'Regular upgrades'],
    image: 'https://customer-assets.emergentagent.com/job_stemkits-lms/artifacts/gfcmsfg9_Gemini_Generated_Image_pgbrhspgbrhspgbr.png'
  },
  {
    id: 7,
    title: 'CodeBunny',
    description: 'Our proprietary block-based coding software designed specifically for young learners. CodeBunny makes programming fun and accessible with drag-and-drop interfaces, animated characters, and gamified learning experiences.',
    icon: 'Code',
    features: ['Block-based visual programming', 'Gamified learning modules', 'Real-time code preview', 'Export to Python/JavaScript'],
    image: 'https://customer-assets.emergentagent.com/job_stemkits-lms/artifacts/irujbyiy_Gemini_Generated_Image_okx0ghokx0ghokx0.png'
  }
];

export const products = [
  {
    id: 1,
    name: 'Basic Robotics & Coding Kit',
    grade: 'Grade 6-8',
    description: 'Microcontroller-based kit perfect for beginners to learn fundamentals of robotics and programming. Includes LMS access for guided learning.',
    price: 30800,
    gst: 18,
    priceWithGst: 36344,
    image: 'https://customer-assets.emergentagent.com/job_stemkits-lms/artifacts/3khi2rm5_Gemini_Generated_Image_gc5fd5gc5fd5gc5f.png',
    badge: 'Bestseller',
    features: ['Microcontroller Board', '20+ Electronic Components', '15 Guided Projects', 'LMS Access & Online Support']
  },
  {
    id: 2,
    name: 'Intermediate Robotics Kit',
    grade: 'Grade 9-12',
    description: 'Advanced microcontroller with Python programming for building sophisticated robots and IoT projects. Includes LMS access for comprehensive learning.',
    price: 35400,
    gst: 18,
    priceWithGst: 41772,
    image: 'https://customer-assets.emergentagent.com/job_stemkits-lms/artifacts/988qx3p2_Gemini_Generated_Image_irrb1xirrb1xirrb.png',
    badge: 'Advanced',
    features: ['Microcontroller Board', '50+ Components', '25 Advanced Projects', 'LMS Access & AI/ML Introduction']
  },
  {
    id: 3,
    name: 'Edupreneur Freedom Model',
    grade: 'Educators & Entrepreneurs',
    description: 'Complete business model package including robotics kit, training, and B2B/B2C/B2G market access. Includes full LMS platform access.',
    price: 18172,
    originalPrice: 36344,
    image: 'https://customer-assets.emergentagent.com/job_stemkits-lms/artifacts/4vndhx1u_Gemini_Generated_Image_u059lbu059lbu059.png',
    badge: '50% OFF',
    features: ['Full Robotics Kit', 'Business Training', 'LMS Platform Access', 'Marketing Materials']
  }
];

export const fiveEs = [
  { id: 1, letter: 'E', title: 'Engage', description: 'Capture curiosity through real-world problems and hands-on challenges.', icon: 'Sparkles' },
  { id: 2, letter: 'E', title: 'Explore', description: 'Investigate concepts through experimentation and discovery.', icon: 'Search' },
  { id: 3, letter: 'E', title: 'Explain', description: 'Articulate understanding through demonstrations and discussions.', icon: 'MessageCircle' },
  { id: 4, letter: 'E', title: 'Elaborate', description: 'Apply knowledge to new situations and complex challenges.', icon: 'Layers' },
  { id: 5, letter: 'E', title: 'Evaluate', description: 'Assess learning through portfolios, projects, and reflections.', icon: 'CheckCircle' }
];

export const testimonials = [
  {
    id: 1,
    name: 'Dr. Shweta Rangan',
    role: 'Chief Advisor - STEM Education',
    quote: 'Every child in essence is a leader and an entrepreneur of tomorrow. Let us nurture them with love and honour.',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=200'
  },
  {
    id: 2,
    name: 'Rajesh Kumar',
    role: 'Principal, Delhi Public School',
    quote: 'STEAM-IE transformed how our students perceive science and technology. The engagement levels are unprecedented.',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200'
  },
  {
    id: 3,
    name: 'Priya Sharma',
    role: 'Parent & Education Advocate',
    quote: 'My daughter went from being screen-dependent to creating her own robots. STEAM-IE made learning truly productive.',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200'
  }
];

export const events = [
  {
    id: 1,
    title: '1 MILE 2027',
    subtitle: '1 Million Entrepreneurs Initiative',
    date: 'June 15-20, 2027',
    location: 'Pan India (Virtual + Physical)',
    description: 'Join the movement to create 1 million young entrepreneurs through STEAM education and innovation.',
    type: 'flagship',
    registrationOpen: true
  },
  {
    id: 2,
    title: 'STEAM Innovation Summit',
    subtitle: 'Annual Educator Conference',
    date: 'April 5-6, 2026',
    location: 'Raipur & Ranchi',
    description: 'Two-day conference for educators featuring workshops, networking, and the latest in STEM pedagogy.',
    type: 'conference',
    registrationOpen: true
  },
  {
    id: 3,
    title: 'Young Innovators Challenge',
    subtitle: 'National Robotics Competition',
    date: 'May 10-12, 2026',
    location: 'Raipur & Ranchi',
    description: 'Students compete in robotics challenges, coding competitions, and innovation showcases.',
    type: 'competition',
    registrationOpen: true
  },
  {
    id: 4,
    title: 'Teacher Certification Program',
    subtitle: 'Professional Development',
    date: 'Ongoing - Monthly Batches',
    location: 'Online',
    description: 'Become a STEAM-IE certified educator with our comprehensive training and certification program.',
    type: 'training',
    registrationOpen: true
  }
];

export const navLinks = [
  { name: 'Home', path: '/' },
  { name: 'Offerings', path: '/offerings' },
  { name: 'Products', path: '/products' },
  { name: 'Events', path: '/events' },
  { name: 'About', path: '/about' },
  { name: 'Contact', path: '/contact' }
];

export const footerLinks = {
  company: [
    { name: 'About Us', path: '/about' },
    { name: 'Our Team', path: '/about' },
    { name: 'Events', path: '/events' },
    { name: 'Contact', path: '/contact' }
  ],
  offerings: [
    { name: 'K-12 STEM Education', path: '/offerings' },
    { name: 'STEAM-IE Kits', path: '/products' },
    { name: 'LMS Platform', path: '/offerings' },
    { name: 'School Partnerships', path: '/offerings' }
  ],
  legal: [
    { name: 'Terms & Conditions', path: '/terms' },
    { name: 'Privacy Policy', path: '/privacy' },
    { name: 'Refund Policy', path: '/refund' },
    { name: 'Shipping Policy', path: '/shipping' },
    { name: 'Cookie Policy', path: '/cookies' },
    { name: 'Disclaimer', path: '/disclaimer' }
  ]
};

export const aboutContent = {
  mission: 'To transform every learner into an innovative entrepreneur through world-class STEAM education, nurturing critical thinking, creativity, and leadership skills for the challenges of tomorrow.',
  vision: 'To be India\'s leading credentialing company for STEAM Education, Innovation & Entrepreneurship, empowering 1 million young entrepreneurs by 2030.',
  values: [
    { title: 'Innovation', description: 'Constantly evolving our methods and curriculum to stay ahead of technological advancements.' },
    { title: 'Excellence', description: 'Maintaining the highest standards in education delivery and student outcomes.' },
    { title: 'Inclusivity', description: 'Making quality STEAM education accessible to students across all backgrounds.' },
    { title: 'Integrity', description: 'Building trust through transparent practices and genuine commitment to student success.' }
  ],
  team: [
    { name: 'Rachit Arora', role: 'CEO', image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=300' },
    { name: 'Anshu Jha', role: 'COO', image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=300' },
    { name: 'Bhavansh Arora', role: 'CTO', image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300' }
  ]
};
